<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer001">
<p class="content-title" id="calibre_toc_1">Navigating College With the 7 Habits</p>
<p class="normal"><span class="bold">A Digital Book to Help You Succeed In School and in Life</span></p>
<p class="normal"><span class="bold1">Sean Covey</span></p>
<p class="normal1"><span class="charoverride"><img alt="" class="_idgenobjectattribute" src="OEBPS/image/MangobzLogo.png"/></span></p>
<p class="normal2" id="calibre_pb_0"><em class="italic">Mango Publishing<br class="calibre1"/></em><span class="charoverride1">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_000.vue?e831c030